import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

type UseTabsSyncWithUrlProps = [
  string, // activeKey
  (key: string) => void // onTabChange function
];

const useTabsSyncWithUrl = (defaultTab: string = 'tab1'): UseTabsSyncWithUrlProps => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeKey, setActiveKey] = useState<string>(defaultTab);

  // Sync the selected tab with the URL
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const tab = queryParams.get('tab') || defaultTab; // Default to provided defaultTab if not in URL
    setActiveKey(tab);
  }, [location, defaultTab]);

  // Update the URL when the active tab changes, without adding to history
  const onTabChange = (key: string) => {
    setActiveKey(key);
    navigate({
      pathname: location.pathname,
      search: `?tab=${key}`,
    }, { replace: true }); // Replace the current history entry
  };

  return [activeKey, onTabChange];
};

export default useTabsSyncWithUrl;
